import { render } from "./ComponenteDemandaVapor.vue?vue&type=template&id=70aa6d0a&scoped=true"
import script from "./ComponenteDemandaVapor.vue?vue&type=script&lang=js"
export * from "./ComponenteDemandaVapor.vue?vue&type=script&lang=js"

import "./ComponenteDemandaVapor.vue?vue&type=style&index=0&id=70aa6d0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70aa6d0a"]])

export default __exports__